import { FormLabel } from '@mui/material';
import pallet from '../../../layouts/pallet';
import styled from 'styled-components';
import { fontSizes } from '../../../layouts/fontSizes';

const LabelText = styled(FormLabel)(() => ({
  color: `${pallet.formLabelText} !important`,
  fontSize: fontSizes.placeHolder,
  fontWeight: '600 !important',
}));

const arrowButtonSx = {
  '& svg': { fill: pallet.primary }
};

const datePickerSlotProps = {
  popper: {
    sx: {
      zIndex: 19999,
      '& .MuiPickersCalendarHeader-root': {
        display: 'flex',
        justifyContent: 'space-between',
        position: 'relative'
      },
      '& .MuiPickersCalendarHeader-labelContainer': {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1
      }
    }
  },
  calendarHeader: {
    sx: {
      '& .MuiPickersArrowSwitcher-root': {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 0,
        mx: 0
      }
    }
  },
  day: {
    sx: {
      '&.Mui-selected': {
        backgroundColor: pallet.primary,
        color: pallet.white,
        '&:hover': {
          backgroundColor: pallet.primary
        },
        '&:focus': {
          backgroundColor: pallet.primary
        }
      }
    }
  },
  yearButton: {
    sx: {
      '&.Mui-selected': {
        backgroundColor: pallet.primary,
        color: pallet.white,
        '&:hover': {
          backgroundColor: pallet.primary
        },
        '&:focus': {
          backgroundColor: pallet.primary
        }
      }
    }
  },
  textField: {
    sx: {
      '& .MuiOutlinedInput-root': {
        height: '40px'
      },
      '& .MuiOutlinedInput-input': {
        padding: '10px 14px',
        height: '40px'
      },
      '& .MuiInputBase-input': {
        padding: '10px 14px',
        height: '40px'
      },
      '& .MuiPickersInputBase-sectionsContainer': {
        height: '40px',
        display: 'flex',
        alignItems: 'center'
      }
    }
  }
};

export { LabelText, arrowButtonSx, datePickerSlotProps };